export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14745.42f125a8.jpg";